/** Claim-level prior auth fields from professional (CMS-1500 box 23) or institutional (UB-04 63). */
export interface IClaimPriorAuthorizationSource {
    f23PrimaryPayerPriorAuthorizationNumber?: string;
    f23SecondaryPayerPriorAuthorizationNumber?: string;
    f23TertiaryPayerPriorAuthorizationNumber?: string;
    f63aTreatmentAuthorizationCode?: string;
    f63bTreatmentAuthorizationCode?: string;
    f63cTreatmentAuthorizationCode?: string;
}

export interface IClaimPriorAuthorization {
    label: string;
    number: string;
}

function trimOrUndefined(value?: string): string | undefined {
    const trimmed = value?.trim();
    return trimmed || undefined;
}

export function getClaimPriorAuthorizations(
    template?: IClaimPriorAuthorizationSource | null,
): IClaimPriorAuthorization[] {
    if (!template) {
        return [];
    }

    const result: IClaimPriorAuthorization[] = [];

    const primary = trimOrUndefined(template.f23PrimaryPayerPriorAuthorizationNumber)
        ?? trimOrUndefined(template.f63aTreatmentAuthorizationCode);
    if (primary) {
        result.push({ label: 'Prior Auth', number: primary });
    }

    const secondary = trimOrUndefined(template.f23SecondaryPayerPriorAuthorizationNumber)
        ?? trimOrUndefined(template.f63bTreatmentAuthorizationCode);
    if (secondary) {
        result.push({ label: 'Secondary Auth', number: secondary });
    }

    const tertiary = trimOrUndefined(template.f23TertiaryPayerPriorAuthorizationNumber)
        ?? trimOrUndefined(template.f63cTreatmentAuthorizationCode);
    if (tertiary) {
        result.push({ label: 'Tertiary Auth', number: tertiary });
    }

    return result;
}

/** @deprecated Use getClaimPriorAuthorizations instead. */
export function getClaimPriorAuthorizationNumber(
    template?: IClaimPriorAuthorizationSource | null,
): string | undefined {
    return getClaimPriorAuthorizations(template)[0]?.number;
}
